import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const scrollReveal = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const MakePartner = () => {
    const navigate = useNavigate();

    return (
        <motion.div
            className="make-partner-section"
            variants={scrollReveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
        >
            <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                <span className="horizontal-line"></span>Partner with Magnify Advisory Today
            </motion.h2>
            <motion.p className="sections-description-smco" variants={scrollReveal}>
                Empowering your dreams with trusted financing solutions across the Mumbai Metropolitan Region.
            </motion.p>
            <motion.button
                className="landing-container-cta-smco"
                variants={scrollReveal}
                onClick={() => navigate("/channel-partner")}
            >
                Become a Partner
            </motion.button>
            <motion.p className="sections-description-smco" variants={scrollReveal}>
                Ready to take the next step? Reach out via phone, email, or visit our office. Our team is standing by to help you achieve your financial goals.
            </motion.p>
        </motion.div>
    );
};

export default MakePartner;
